export class Pagination {
    totalRecords: number = 0;
    pageNumber: number = 1;
    pageSize: number = 20;
}